import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { useQuery } from 'react-apollo';
import Modal from 'react-modal';

import { useAuthService } from '@/contexts/authService';

import {
  UserQueryPrivate,
  UserQueryPublicBasic,
} from '../../state/services/gql/user';

import HeaderMenu from '../../components/HeaderMenu';
import {
  getHash,
  getObjFromHashParamString,
  updateHash,
} from '../../utils/urls';

import { headerStackedListBreakpoint } from '../../base-styles/vars';

import MyEventsProductMarketingModal from '../MyEventsProductMarketingModal';

const hashObj = getObjFromHashParamString(getHash());

Modal.setAppElement('#app');

/**
 * Header menu container component.
 * Wraps the header menu in state to control visibility.
 */
class HeaderMenuContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      categoriesVisible: false,
      navVisible: false,
      searchVisible: hashObj && hashObj.target === 'search',
      showModal: false,
    };
  }

  handleButtonClick = (event) => {
    const { target } = event || {};
    if (target) {
      target.blur();
    }
    this.toggleNavVisibility();
  };

  handleCategoriesClick = () => {
    this.toggleCategoriesVisibility();
  };

  handleCategoriesMouseEnterOrLeave = () => {
    // headerStackedListBreakpoint == '1000px', so trim the last two chars
    const headerStackedListBreakpointSize = headerStackedListBreakpoint.slice(
      0,
      -2,
    );
    if (window.innerWidth >= headerStackedListBreakpointSize) {
      this.toggleCategoriesVisibility();
    }
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

  toggleCategoriesVisibility = () => {
    this.setState(({ categoriesVisible }) => ({
      categoriesVisible: !categoriesVisible,
    }));
  };

  handleClickOutside = () => {
    this.setState({ categoriesVisible: false });
  };

  toggleNavVisibility = () => {
    this.setState(({ navVisible }) => ({
      navVisible: !navVisible,
      categoriesVisible: false,
    }));
  };

  handleSearchClick = () => {
    this.toggleSearchVisibility();
  };

  toggleSearchVisibility = () => {
    this.setState(({ searchVisible }) => ({
      searchVisible: !searchVisible,
    }));

    if (hashObj && hashObj.target === 'search') {
      hashObj.target = undefined;
      updateHash(hashObj, true);
    }
  };

  render() {
    const hasUserCookie = this.props.authService.hasUserCookie();
    const { profile } = this.props.data || {};

    return (
      <>
        <MyEventsProductMarketingModal
          onClose={this.toggleModal}
          show={this.state.showModal}
        />
        <HeaderMenu
          hasUserCookie={hasUserCookie}
          profile={profile}
          onButtonClick={this.handleButtonClick}
          onCategoriesClick={this.handleCategoriesClick}
          onCategoriesMouseEnterOrLeave={this.handleCategoriesMouseEnterOrLeave}
          onMyEventsClick={this.toggleModal}
          onMaskClick={this.handleButtonClick}
          onNavCloseClick={this.handleButtonClick}
          onNavLinkClick={this.handleButtonClick}
          onSearchCloseClick={this.handleSearchClick}
          onSearchLinkClick={this.handleSearchClick}
          selectedLocale={this.props.selectedLocale}
          userSelectedLocale={this.props.userSelectedLocale}
          {...this.props}
          {...this.state}
        />
      </>
    );
  }
}

HeaderMenuContainer.propTypes = {
  data: PropTypes.shape(),
  selectedLocale: PropTypes.string,
  userSelectedLocale: PropTypes.string,
};

HeaderMenuContainer.defaultProps = {
  data: {},
  selectedLocale: undefined,
  userSelectedLocale: undefined,
};

export default (props) => {
  const authService = useAuthService();
  const Query = authService.loggedIn ? UserQueryPrivate : UserQueryPublicBasic;
  const query = useQuery(Query, {
    variables: { id: authService.getUserCookie() },
    skip: !authService.getUserCookie(),
  });

  return (
    <HeaderMenuContainer {...props} {...query} authService={authService} />
  );
};
